/* Magic system — orchestrator for TIER 2 (sparkles) + TIER 3 (butterfly).
 * TIER 1 (passive particles) is CSS-only and needs no JS.
 * Progressive enhancement: any failure here leaves particles + shine intact.
 */
(function () {
  'use strict';

  var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reducedMotion) return;

  var isMobile = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;

  function init() {
    initButterfly();
    initSparkles();
    initVariantInteraction();
    initHeroViewportPause();
    initAmbientViewportPause();
  }

  /* ---------- TIER 3 — Butterfly cycle ---------- */
  function initButterfly() {
    var butterfly = document.querySelector('.hero-editorial .magic-butterfly');
    if (!butterfly) return;

    var DRIFT_MS = 22000; // must match CSS keyframe duration
    var minWait = isMobile ? 28000 : 14000;
    var maxWait = isMobile ? 50000 : 28000;

    function playOnce() {
      butterfly.classList.remove('is-active');
      // Force reflow so the animation restarts cleanly
      void butterfly.offsetWidth;
      // Randomize vertical start between 18% and 62% of hero height
      butterfly.style.top = (18 + Math.random() * 44).toFixed(1) + '%';
      butterfly.classList.add('is-active');
      window.setTimeout(schedule, DRIFT_MS + 500);
    }

    function schedule() {
      var wait = minWait + Math.random() * (maxWait - minWait);
      window.setTimeout(playOnce, wait);
    }

    // Initial delay so the hero has time to settle in
    window.setTimeout(playOnce, 4500);
  }

  /* ---------- TIER 2 — Click sparkle burst ---------- */
  function initSparkles() {
    document.addEventListener('click', function (e) {
      if (!e.target || !e.target.closest) return;

      // Primary CTAs: 3 sparkles
      var button = e.target.closest('.button, [data-magic-sparkle]');
      var count = 0;
      if (button) {
        count = 3;
      } else {
        // Editorial links: 2 sparkles (more discreet)
        var link = e.target.closest('.link-luxury');
        if (link) count = 2;
      }
      if (!count) return;

      var x = (typeof e.clientX === 'number') ? e.clientX : null;
      var y = (typeof e.clientY === 'number') ? e.clientY : null;
      if (x === null || y === null) {
        var host = button || e.target.closest('.link-luxury');
        var rect = host.getBoundingClientRect();
        x = rect.left + rect.width / 2;
        y = rect.top + rect.height / 2;
      }
      spawnSparkles(x, y, count);
    }, true);
  }

  var SPARKLE_SVG =
    '<svg viewBox="0 0 10 10" fill="currentColor" aria-hidden="true">' +
      '<path d="M5 0 L5.7 4.3 L10 5 L5.7 5.7 L5 10 L4.3 5.7 L0 5 L4.3 4.3 Z"/>' +
    '</svg>';

  function spawnSparkles(x, y, count) {
    count = count || 3;
    for (var i = 0; i < count; i++) {
      var span = document.createElement('span');
      span.className = 'magic-sparkle';
      span.innerHTML = SPARKLE_SVG;
      span.style.left = x + 'px';
      span.style.top = y + 'px';
      var angle = (i / count) * Math.PI * 2 + Math.random() * 0.8;
      var dist = 22 + Math.random() * 12;
      span.style.setProperty('--sx', (Math.cos(angle) * dist).toFixed(1) + 'px');
      span.style.setProperty('--sy', (Math.sin(angle) * dist).toFixed(1) + 'px');
      document.body.appendChild(span);
      (function (el) {
        window.setTimeout(function () {
          if (el && el.parentNode) el.parentNode.removeChild(el);
        }, 720);
      })(span);
    }
  }

  /* ---------- F5 — Variant interaction (swatches, sizes, price) ---------- */
  function initVariantInteraction() {
    document.addEventListener('change', function (e) {
      var input = e.target;
      if (!input) return;
      var tag = input.tagName;
      if (tag !== 'INPUT' && tag !== 'SELECT') return;

      // Only react inside a variant option context
      var optionWrap = input.closest && input.closest('.variant-option');
      if (!optionWrap) return;

      // Radio: pulse + sparkles on the label
      if (tag === 'INPUT' && input.type === 'radio') {
        var label = input.closest('.variant-option__button-label');
        if (label) {
          var isSwatch = label.classList.contains('variant-option__button-label--has-swatch');
          var pulseClass = isSwatch ? 'magic-variant-pulse--swatch' : 'magic-variant-pulse--size';
          var holdMs = isSwatch ? 1050 : 800;

          // Restart animation cleanly
          label.classList.remove(pulseClass);
          void label.offsetWidth;
          label.classList.add(pulseClass);

          (function (el, cls) {
            window.setTimeout(function () {
              el.classList.remove(cls);
            }, holdMs);
          })(label, pulseClass);

          var rect = label.getBoundingClientRect();
          spawnSparkles(rect.left + rect.width / 2, rect.top + rect.height / 2, 2);
        }
      }

      // Trigger price fade on any variant change (radio OR select)
      var priceContainers = document.querySelectorAll('[ref="priceContainer"]');
      for (var i = 0; i < priceContainers.length; i++) {
        var pc = priceContainers[i];
        pc.classList.remove('magic-price-update');
        void pc.offsetWidth;
        pc.classList.add('magic-price-update');
        (function (el) {
          window.setTimeout(function () {
            el.classList.remove('magic-price-update');
          }, 360);
        })(pc);
      }
    }, false);
  }

  /* ---------- Pause magic when hero is out of viewport ---------- */
  function initHeroViewportPause() {
    if (!('IntersectionObserver' in window)) return;
    var heroes = document.querySelectorAll('.hero-editorial');
    if (!heroes.length) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.removeAttribute('data-magic-paused');
        } else {
          entry.target.setAttribute('data-magic-paused', '');
        }
      });
    }, { threshold: 0 });

    heroes.forEach(function (el) { io.observe(el); });
  }

  /* ---------- F10 — Pause ambient layers when out of viewport ---------- */
  function initAmbientViewportPause() {
    if (!('IntersectionObserver' in window)) return;
    var layers = document.querySelectorAll('.ambient-layer');
    if (!layers.length) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.removeAttribute('data-ambient-paused');
        } else {
          entry.target.setAttribute('data-ambient-paused', '');
        }
      });
    }, { threshold: 0 });

    layers.forEach(function (el) { io.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
